/**
 * Flatten an HTML fragment to single-line plain text for clamped previews.
 * Block-level boundaries become spaces so list items and paragraphs don't
 * run together.
 */
export function htmlToText(html: string): string {
  const withBreaks = html.replace(
    /<\/(p|div|li|ul|ol|h[1-6]|tr|blockquote)>|<br\s*\/?>/gi,
    "$& ",
  );
  const doc = new DOMParser().parseFromString(withBreaks, "text/html");
  return (doc.body.textContent ?? "").replace(/\s+/g, " ").trim();
}
